export const marketPresales: { [key: string]: string } = {
  albany: 'https://app.viralsweep.com/sweeps/full/cf05bb-150432?framed=1',
  charlotte: 'https://app.viralsweep.com/sweeps/full/4df64a-150433?framed=1',
  columbus: '',
  minneapolis: 'https://app.viralsweep.com/sweeps/full/5b371d-150435?framed=1',
  fairfield: 'https://app.viralsweep.com/sweeps/full/49608d-150436?framed=1',
  dallas: '',
  baltimore: 'https://app.viralsweep.com/sweeps/full/8a11d4-150439?framed=1',
  denver: 'https://app.viralsweep.com/sweeps/full/43179c-150440?framed=1',
  seattle: 'https://app.viralsweep.com/sweeps/full/52a987-150442?framed=1',
  louisville: 'https://app.viralsweep.com/sweeps/full/ac5cd4-150437?framed=1',
  'salt-lake-city': '',
  boston: 'https://app.viralsweep.com/sweeps/full/65da9e-150438?framed=1',
  'washington-dc': '',
  'long-island': '',
  philadelphia: 'https://app.viralsweep.com/sweeps/full/28c605-150434?framed=1',
  atlanta: '',
  'san-jose': '',
  'colorado-springs': '',
  'san-diego': 'https://app.viralsweep.com/sweeps/full/ebad4c-150441?framed=1',
  quarterfinals: '',
  semifinals: '',
  championship: '',
}

//Market pages
export const marketSlugs = [
  'albany',
  'charlotte',
  'columbus',
  'minneapolis',
  'fairfield',
  'dallas',
  'baltimore',
  'denver',
  'seattle',
  'salt-lake-city',
  'boston',
  'washington-dc',
  'long-island',
  'philadelphia',
  'atlanta',
  'kansas-city',
  'chicago',
  'san-jose',
  'colorado-springs',
  'san-diego',
  'quarterfinals',
  'semifinals',
  'championship',
]

export const homecomingWeekends: { [key: string]: string } = {
  albany: 'ATL',
  charlotte: 'CHA',
  baltimore: 'WHP',
  denver: 'OUT',
  'salt-lake-city': 'ARC',
  boston: 'CAN',
  philadelphia: 'WAT',
  'san-diego': 'RED',
}

export const playoffLocationMap: { [key: string]: string } = {
  quarterfinals: '',
  semifinals: '',
  championship: '',
}

export type MarketSelector = {
  week: number
  name: string
  openTime: number
  closeTime: number
}

export const marketSelectors: MarketSelector[] = [
  {
    week: 1,
    name: 'Albany, NY',
    openTime: 1747781701,
    closeTime: 1748933940,
  },
  {
    week: 2,
    name: 'Charlotte, NC',
    openTime: 1748933941,
    closeTime: 1749538740,
  },
  {
    week: 3,
    name: 'Villanova, PA',
    openTime: 1749538741,
    closeTime: 1750143540,
  },
  {
    week: 4,
    name: 'Baltimore, MD',
    openTime: 1750143541,
    closeTime: 1750748340,
  },
  {
    week: 5,
    name: 'San Diego, CA',
    openTime: 1750748341,
    closeTime: 1751353140,
  },
  {
    week: 6,
    name: 'Kansas City, MO',
    openTime: 1751353141,
    closeTime: 1751957940,
  },
  {
    week: 7,
    name: 'Chicago, IL',
    openTime: 1751957941,
    closeTime: 1752562740,
  },
  {
    week: 8,
    name: 'Fairfield, CT',
    openTime: 1752562741,
    closeTime: 1753167540,
  },
  {
    week: 9,
    name: 'Salt Lake City, UT',
    openTime: 1753167541,
    closeTime: 1753772340,
  },
  {
    week: 10,
    name: 'Denver, CO',
    openTime: 1753772341,
    closeTime: 1754377140,
  },
  {
    week: 11,
    name: 'Boston, MA',
    openTime: 1754377140,
    closeTime: 1755586800,
  },
  {
    week: 12,
    name: 'Minneapolis, MN',
    openTime: 1755586801,
    closeTime: 1756191600,
  },
  {
    week: 13,
    name: 'Philadelphia, PA',
    openTime: 1756191601,
    closeTime: 1756796400,
  },
  {
    week: 14,
    name: 'Harrison, NJ',
    openTime: 1756796401,
    closeTime: 1757401200,
  },
]
